
  <p-multiSelect 
    [options]="sourceData" 
    [(ngModel)]="selectedValueModel" 
    optionLabel= {{optionValue}} 
    optionValue={{optionLable}} 
    placeholder={{optionHeader}}
    loading=true
    virtualScroll={{virtualScroll}} 
    [virtualScrollItemSize]="33"
    (onChange)="onItemChange($event)"
    autoWidth="false"
    [showClear]="true"
    [maxSelectedLabels]="1"
    resetFilterOnHide=true
    [style]="{ minWidth: '100px', width: '100%' }"
    [showToggleAll]="false"
    >
  
   
  </p-multiSelect>

  